export function resolveCountryCode(countryCode: string): string {
  switch (countryCode) {
    case 'at':
    case 'ch':
    case 'de':
    case 'fr-ch':
      return 'DE'
    case 'fi':
      return 'FI'
    case 'be':
    case 'nl':
      return 'NL'
    case 'fr-be':
    case 'fr':
      return 'FR'
    default:
      return 'DE'
  }
}
